import React, { useEffect } from "react";
import { Box, Divider } from "@mui/material";
import TableGenerator from "../../../Utils/FormGenerator/TableGenerator";
import { useGetDBKBankQuery } from "../../../redux/ExportPage/CreateNewJob/General/DBKbank";
import { useUser } from "@/Context/UserContext";
import { SectionHeader } from "../../../Components/Header/SectionsHeader";
import { LuX } from "react-icons/lu";

export default function DBKBankList({ onClose }) {
  const { formData, setFormData } = useUser();
const customerId = formData?.general?.exporterId?.id;

  const { data, isLoading } = useGetDBKBankQuery(
    { customerid: customerId },
    { skip: !customerId }
  );
  console.log("DBK Bank Data:", data);
  // 👉 Data fetch aanathudane TableGenerator-ku set
  useEffect(() => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        DBKBank: data, // 🚀 Important — This is the compKey TableGenerator expects
      }));
    }
  }, [data, setFormData]);

  const visibleFields = [
    {
      key: "customDetailsDrawbackAddress",
      label: "Bank name & Address",
      width: 200,
    },
    { key: "customDetailsDrawbackACNo", label: "Bank AC/No", width: 120 },
    { key: "customDetailsDrawbackLedgerNo", label: "Ledger No", width: 120 },
    { key: "customDetailsDrawbackACNo", label: "EDI AC/No", width: 120 },
  ];

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingRight: 2,
          m: 0.5,
        }}
      >
        <SectionHeader title={"DBK Bank"} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            gap: 4,
            alignItems: "center",
            // pr: 2,
            // m: 1,
          }}
        >
          <LuX size={20} style={{ cursor: "pointer" }} onClick={onClose} />
        </Box>
      </Box>
      <Divider />

      <TableGenerator
        compKey="DBKBank" // 👉 This is what TableGenerator reads
        label="DBK Bank"
        visibleFields={visibleFields}
        handlers={{}}
        loading={isLoading}
        actions={[]}

      />
    </Box>
  );
}
